module.exports = __webpack_public_path__ + "static/media/invoice.3dfbc3d3.svg";